import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  states: [],
  requests: [],
  requestsCount: 0,
  requestStats: {},
  currentRequest: null,
  penalties: [],
  penaltiesCount: 0,
};

const slice = createSlice({
  name: "fireDepartment",
  initialState,
  reducers: {
    setFireDepartmentState: (state, action) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key] = value;
      });
    },
  },
});

export const reducer = slice.reducer;

export const setFireDepartmentState = (data) => (dispatch) => {
  dispatch(slice.actions.setFireDepartmentState(data));
};
